import { render, staticRenderFns } from "./driverOrder.vue?vue&type=template&id=54e4b88b&"
import script from "./driverOrder.vue?vue&type=script&lang=js&"
export * from "./driverOrder.vue?vue&type=script&lang=js&"
import style0 from "./driverOrder.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "driverOrder.vue"
export default component.exports